<template>
  <div :class="isMobile?'mobile-foot-button':'foot-button'" @click="complaintAdd">
      <img src="@/assets/images/feedback_consulting.png" class="button_img">
      <span>{{ lang.feedback.footButton }}</span>
    </div>
</template>

<script>
import {  mapGetters } from 'vuex'
export default {
  name: 'footButton',
  computed: {
    ...mapGetters(['isMobile','feedbackQueryStr','lang'])
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    complaintAdd () {
      this.$router.push({ path: '/complaintAdd?' + this.feedbackQueryStr })
    }
  }
}
</script>

<style lang="scss">

</style>
